export class AnalyticsDimensionMappings {
    [name: string]: string;
}